import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import Regex from "../../../Utilities/Regex";
import ButtonLoader from "../../CommonComponent/ButtonLoader/ButtonLoader";
import { useDispatch } from "react-redux";
import { AgentWalletHistoryContext } from "../../AgentWalletHistoryComponent/AgentWalletHistoryComponent";
import { useForm } from "react-hook-form";
import { agentCollectionHistoryAction } from "../../../Redux/Action/AgentAction";
import { AgentCollectionHistoryContext } from "../AgentCollectionHistoryCoponent";
import { collectionAmountAction, organizationAction } from '../../../Redux/Action/MemberAction';
import { TiDelete } from 'react-icons/ti';
import { RxCross2 } from 'react-icons/rx';
import Auth from '../../../Utilities/Auth';
import CollectionHistorySearchHandler from '../Handler/CollectionHistorySearchHandler';

function CollectionHistoryForm(props) {
    //ref
    const btnRef = useRef()
    // Hook
    const dispatch = useDispatch()

    // Context
    const {
        agentCollectionHistory,
        setAgentCollectionHistory,
        setFilteredAgentCollectionHistory
    } = useContext(AgentCollectionHistoryContext)


    //state
    const [organizationList, setOrganizationList] = useState([])
    const [getCollectionAmount, setGetCollectionAmount] = useState([])

    const user_detail = JSON.parse(Auth.header().userdetail)


    // making active years lifecycle
    // useEffect(() => {
    //     const payload = {
    //         setOrganizationList,
    //         setGetCollectionAmount
    //     }

    //     dispatch(organizationAction(payload))
    //     dispatch(collectionAmountAction(payload))

    // }, [setOrganizationList, setGetCollectionAmount])


    useEffect(() => {
        // const agent_id= 
        const payload = {
            data: { row_count: 200, agent_id: user_detail?.is_admin ? "" : user_detail?.id },
            reset,
            btnRef,
            setAgentCollectionHistory
        }
        dispatch(agentCollectionHistoryAction(payload))

    }, [])


    // hook form
    const { register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();

    const onSubmit = data => {
        //console.log(data)
        const payload = {
            data: { ...data, agent_id: user_detail?.is_admin ? data.agent_id : user_detail?.id },
            reset,
            btnRef,
            setAgentCollectionHistory
        }
        dispatch(agentCollectionHistoryAction(payload))
    }

    return (
        <>
            {user_detail?.is_admin == "1" && <form className='d-none' onSubmit={handleSubmit(onSubmit)}>
                {/*Agent full_name field*/}
                <Row>

                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Collector Id"
                                    {...register("agent_id", {
                                        required: false,
                                        pattern: Regex.numeric()
                                    })}

                                // onBlur={()=>{}}
                                />
                                <RxCross2 onClick={e => {
                                    setValue("agent_id")
                                    document.getElementById("collectionSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                            </div>
                            {/* validation message*/}
                            {errors.agent_id && <span className="text-danger">
                                {errors.agent_id.type === "required" && "Please Give Collector Id"}
                                {errors.agent_id.type === "pattern" && "Please Give Valid Collector Id"}
                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3 select78" controlId="formBasicEmail">
                            <Form.Select aria-label="Default select example" {...register("organization_id",)}>
                                <option value="">Select Organization</option>
                                {organizationList.map((singleOrg, index) => (
                                    <option key={index} value={singleOrg.id}>{singleOrg.organization_name}</option>
                                ))}

                            </Form.Select>


                        </Form.Group>
                    </Col>

                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3 select78" controlId="formBasicEmail">
                            <Form.Select aria-label="Default select example" {...register("collection_amount")}>
                                <option value="">Select Amount</option>
                                {getCollectionAmount.map((singleOrg, index) => (
                                    <option key={index} value={singleOrg.collection_amount}>{singleOrg.collection_amount}</option>
                                ))}

                            </Form.Select>


                        </Form.Group>
                    </Col>
                    <Col md={2} sm={12}>
                        <Button id='collectionSubmitButton' ref={btnRef} variant="primary" type="submit" className="submit">
                            Submit
                            <ButtonLoader />
                        </Button>
                    </Col>
                </Row>

            </form>}

            <CollectionHistorySearchHandler preFilteredData={agentCollectionHistory} setFilteredDataState={setFilteredAgentCollectionHistory} />
        </>
    );
}

export default CollectionHistoryForm;